import React from "react";
import PropTypes from "baobab-react/prop-types";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";
import autoBind from "react-autobind";

import { Panel } from "react-bootstrap";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";

import { getConfigParam } from "../../utils/config";
import PlayerItemWrapper from "../playerItemComponents/PlayerItemWrapper";
import PlayerItemGroup from "../playerItemComponents/PlayerItemGroup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


class Section extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	componentDidMount() {
		window.addEventListener("resize", _.debounce(this.onResize, 50));
	}

	componentWillUnmount() {
		window.removeEventListener("resize", _.debounce(this.onResize, 50));
	}

	onResize() {
		this.forceUpdate();
	}

	render() {
		let self = this;
		let section = this.props.section;

		const webMode = getConfigParam("webMode", false);

		let sectionCompletionColor = Utils.getCompletionStateColor(section.completionState);

		let i = this.props.listIndex;
		let j = this.props.sectionIndex;

		let canvasWidth, itemSizeWidth, itemSizeHeight, itemFontSize;

		canvasWidth = window.innerWidth;

		if (canvasWidth >= 1200) {
			if (this.props.sectionsCount < 16) {
				if (window.innerWidth < window.innerHeight) {
					itemSizeWidth = canvasWidth / 3 - 10;
					itemSizeHeight = (canvasWidth / 3 - 10) * .6;
					itemFontSize = 28;
				} else {
					itemSizeWidth = canvasWidth / 5 - 10;
					itemSizeHeight = (canvasWidth / 5 - 10) * .6;
					itemFontSize = 24;
				}

			} else {
				if (window.innerWidth < window.innerHeight) {
					itemSizeWidth = canvasWidth / 5 - 10;
					itemSizeHeight = (canvasWidth / 5 - 10) * .6;
					itemFontSize = 24;
				} else {
					itemSizeWidth = canvasWidth / 7 - 10;
					itemSizeHeight = (canvasWidth / 7 - 10) * .6;
					itemFontSize = 20;
				}

			}
		} else if (canvasWidth >= 600) {
			if (this.props.sectionsCount < 16) {
				if (window.innerWidth < window.innerHeight) {
					itemSizeWidth = canvasWidth / 3 - 10;
					itemSizeHeight = (canvasWidth / 3 - 10) * .6;
					itemFontSize = 20;
				} else {
					itemSizeWidth = canvasWidth / 5 - 10;
					itemSizeHeight = (canvasWidth / 5 - 10) * .6;
					itemFontSize = 16;
				}

			} else {
				if (window.innerWidth < window.innerHeight) {
					itemSizeWidth = canvasWidth / 5 - 10;
					itemSizeHeight = (canvasWidth / 5 - 10) * .6;
					itemFontSize = 16;
				} else {
					itemSizeWidth = canvasWidth / 7 - 10;
					itemSizeHeight = (canvasWidth / 7 - 10) * .6;
					itemFontSize = 14;
				}

			}

		} else {
			if (window.innerWidth < window.innerHeight) {
				itemSizeWidth = canvasWidth / 3 - 10;
				itemSizeHeight = (canvasWidth / 3 - 10) * .6;
				itemFontSize = 10;
			} else {
				itemSizeWidth = canvasWidth / 5 - 10;
				itemSizeHeight = (canvasWidth / 5 - 10) * .6;
				itemFontSize = 10;
			}

		}

		let groupStack = [];
		let items = [];
		let groupCounter = 0;

		_.each(section.children, (item, k) => {

			let isEndOfGroup = !!item.isEndOfGroup;
			let isStartOfGroup = !!item.isStartOfGroup;
			if (isStartOfGroup) {
				groupCounter++;
				const newGroup = { id: `group-${i}-${j}-${groupCounter}`, items: [], leadItemGuid: item.guid, leadItemId: item.id };
				console.log("TEST GROUP NAME - START OF GROUP", newGroup);
				groupStack.push(newGroup);
			}
			const isInGroup = !_.isEmpty(groupStack);

			let newItem = <PlayerItemWrapper isInGroup={isInGroup} isStartOfGroup={isStartOfGroup} key={`item-wrapper-${i}-${j}-${k}`} item={item} itemIndex={k} sectionIndex={j} listIndex={i} listStyles={this.props.listStyles} sectionStyles={this.props.sectionStyles} activity={this.props.activity} activityIdentityId={this.props.activityIdentityId} readOnly={this.props.readOnly} />;

			if (isInGroup) {
				const currentGroup = _.last(groupStack);
				currentGroup.items.push(newItem); // Add it to the current group
				if (isEndOfGroup) {
					// A group has ended
					if (groupStack.length === 1) {
						// This is the top level group
						items.push(
							<PlayerItemGroup leadItemGuid={currentGroup.leadItemGuid} leadItemId={currentGroup.leadItemId} sectionIndex={self.props.sectionIndex} key={"list" + self.props.listIndex + "section" + self.props.sectionIndex + "itemGroup" + currentGroup.id}>
								{groupStack[0].items}
							</PlayerItemGroup>);
						groupStack = [];
					} else {
						// This isn't the top level group
						const currentGroup = _.last(groupStack);

						const parentGroup = _.nth(groupStack, -2);

						parentGroup.items.push(<PlayerItemGroup leadItemGuid={currentGroup.leadItemGuid} leadItemId={currentGroup.leadItemId} sectionIndex={self.props.sectionIndex} key={"list" + self.props.listIndex + "section" + self.props.sectionIndex + "itemGroup" + currentGroup.id}>
							{currentGroup.items}
						</PlayerItemGroup>);

						_.dropRight(groupStack);
					}
				}
			} else {
				items.push(newItem);
			}
		});

		let sectionBody;
		// let bottomLeftBorderRadius = "3px";
		if (section.expanded) {
			// bottomLeftBorderRadius = "0px";
			sectionBody = <Panel.Body>
				{items}
			</Panel.Body>;
		}

		let sectionComponent;

		let iconColor = section.hasOwnProperty("iconColor") ? section.iconColor : "#ffffff";

		if ((this.props.activity.firstLevel === "lists" || this.props.activity.firstLevel === "sections") && !_.isEmpty(_.trim(section.name))) {

			let completionProgress = this.props.section.progressCount / this.props.section.progressTotal;
			if (!_.isNumber(completionProgress) || _.isNaN(completionProgress)) {
				completionProgress = 0;
			}

			let _styles = {};
			let _titleStyles = {};

			const { resolvedStyles } = section;
			if (resolvedStyles) {
				if (resolvedStyles.section) {
					_styles = resolvedStyles.section;
				}

				if (resolvedStyles.title) {
					_titleStyles = resolvedStyles.title;
				}
			}

			let sectionHeader;

			if (this.props.birdseye) {
				sectionHeader =
					<div onClick={(e) => {
						e.stopPropagation();

						this.props.dispatch(
							playerActions.gotoItemFromSectionsMenu,
							this.props.listIndex,
							this.props.sectionIndex,
							0
						);
					}}>
						<div className="btn-related-item" style={_.assign({}, { display: "flex", position: "relative", flexDirection: "column", alignItems: "center", justifyContent: "center", width: itemSizeWidth, height: itemSizeHeight, marginTop: 5, marginBottom: 12, borderRadius: 10, backgroundColor: (this.props.sectionIndex === this.props.selectedSectionIndex && playerActions.isSelectedVisible()) ? "#448844" : "#888888", marginLeft: 5, marginRight: 5, paddingLeft: 10, paddingRight: 10, overflow: "hidden", cursor: "pointer" })}>
							<div style={{ textAlign: "center", fontSize: itemFontSize+"px", lineHeight: (itemFontSize+2)+"px", color: "#ffffff" }}><span>{Utils.getRealName(section.name)}</span></div>
							<div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: this.props.section.hideStatus ? 0 : 10, backgroundColor: "#BA282A" }} />
							<div style={{ position: "absolute", bottom: 0, left: 0, width: itemSizeWidth * completionProgress, height: this.props.section.hideStatus ? 0 : 10, backgroundColor: sectionCompletionColor }} />
						</div>
					</div>;
			} else {
				sectionHeader =
					<Panel.Heading style={_.assign({}, { padding: "0px 0px 5px 0px", backgroundColor: section.backgroundColor, color: section.color, border: "none" }, _styles)}>
						<div style={{ position: "relative", display: "flex", flexDirection: "row" }}>
							{/* {!webMode && <div className="player-panel-heading-completion-status" style={{ "backgroundColor": sectionCompletionColor, bottomLeftBorderRadius }} />} */}
							<div style={{ marginLeft: 6 }} />
							<div onClick={() => { playerActions.toggleExpandNode(self.context.tree, i, j); }} style={{ cursor: "pointer", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
								<FontAwesomeIcon icon={section.expanded ? ["far", "minus-square"] : ["far", "plus-square"]} style={{ color: iconColor, marginLeft: 10, fontSize: 32 }} />
							</div>
							<div className="player-panel-heading">
								<div className="player-panel-title" style={_titleStyles} onClick={() => { playerActions.toggleExpandNode(self.context.tree, i, j); }}>
									{section.name}
								</div>
							</div>
							{!webMode && <div style={{ position: "absolute", bottom: -5, right: 0, left: 0, height: this.props.section.hideStatus ? 0 : 7, backgroundColor: "#BA282A" }} />}
							{!webMode && <div style={{ position: "absolute", bottom: -5, left: 0, width: (this.props.defaultColumnWidth) * completionProgress, height: this.props.section.hideStatus ? 0 : 7, backgroundColor: sectionCompletionColor }} />}
						</div>
					</Panel.Heading>;
			}


			if (this.props.birdseye) {
				sectionComponent = sectionHeader;
			} else {
				sectionComponent =
					<Panel key={"history-list" + i + "section" + j} style={{ borderColor: section.borderColor, marginTop: "10px" }} bsStyle="default" defaultExpanded={this.props.defaultExpanded}>
						{sectionHeader}
						{sectionBody}
					</Panel>;
			}


			// Show without heading
		} else {
			sectionComponent =
				<div style={{ margin: 10, overflow: "auto" }}>
					{items}
				</div>;
		}
		return sectionComponent;
	}
}


Section.contextTypes = {
	tree: PropTypes.baobab
};

export default branch((props, context) => {
	return {
		selectedSectionIndex: ["activity", "selected", "sectionIndex"],
		activityTheme: ["activity", "theme"],
		user: ["user"],
		readOnly: ["player", "readOnly"],
		defaultColumnWidth: Utils.getDefaultColumnWidthBranchPath(context.tree),
	};

}, Section);